import "../pages.scss"
import { BannersState } from '../../context/banners/BannersState';
import Datatable from "./bannersTable/Datatable";

const BannersPage = () => {

  return (
    <BannersState>
      <Datatable />
    </BannersState>
  );
};

export default BannersPage;
